/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diet_Gluten_FreeInputs */

const en_diet_gluten_free = /** @type {(inputs: Diet_Gluten_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gluten-free`)
};

const de_diet_gluten_free = /** @type {(inputs: Diet_Gluten_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glutenfrei`)
};

/**
* | output |
* | --- |
* | "Gluten-free" |
*
* @param {Diet_Gluten_FreeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const diet_gluten_free = /** @type {((inputs?: Diet_Gluten_FreeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diet_Gluten_FreeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_diet_gluten_free(inputs)
	return en_diet_gluten_free(inputs)
});